// src/components/SkipLink.jsx

import React from 'react';
import './SkipLink.css';

function SkipLink() {
    return (
        <a href="#main-content" className="skip-link">
            Skip to main content
        </a>
    );
}

export default SkipLink;
